const content = {
  lmsCardText: "ACCA Learning - expert learning resources from ACCA and our partners",
  lmsCardCTAText: "Visit ACCA Learning",
};

export default content;
